import { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  formatMoney,
  formatDayMonthYearSlash,
} from '../helpers';

const useInvoiceProfile = () => {
  const { t } = useTranslation();

  const summaryHeaders = useMemo(() => [
    [
      {
        label: 'Monto:',
        getValue: (invoice) => `$${formatMoney(invoice.amountWithIva)}`,
      },
      {
        label: 'Emisor:',
        getValue: (invoice) => `${invoice.company.masterEntity.name}\n${invoice.company.masterEntity.displayNationalIdentifier}`,
      },
      {
        label: 'Deudor:',
        getValue: (invoice) => `${invoice.receiver.name}\n${invoice.receiver.displayNationalIdentifier}`,
      },
    ],
    [
      {
        label: 'Fecha emisión:',
        getValue: (invoice) => `${formatDayMonthYearSlash(invoice.dateIssued)}`,
        lightHeader: true,
      },
      {
        label: `Fecha recepción ${t('National Tax Service acronym')}:`,
        getValue: (invoice) => {
          if (invoice.receptionDate) {
            return `${formatDayMonthYearSlash(invoice.receptionDate)}`;
          }
          return `${formatDayMonthYearSlash(invoice.dateIssued)}`;
        },
      },
      { label: 'Pago:', getValue: (invoice) => invoice.paymentMethod },
      {
        label: 'Comentarios último estado:',
        getValue: (invoice) => (invoice.uniqueDocumentFinanceState.length
          ? invoice.uniqueDocumentFinanceState[0]?.comments
          : 'Sin Comentarios'),
      },
    ],
  ], [t]);

  const needsCreditNote = useCallback((invoice) => {
    if (!invoice) {
      return null;
    }
    const rejected = invoice.siiStatus.includes('REJECTED');
    const totalCredit = invoice.creditNotes
      .map((cn) => cn.amountWithIva)
      .reduce((a, b) => a + b, 0);
    return rejected && totalCredit < invoice.amountWithIva;
  }, []);

  return {
    summaryHeaders,
    needsCreditNote,
  };
};

export default useInvoiceProfile;
